import { render, staticRenderFns } from "./GroupsFilterByGroup.vue?vue&type=template&id=560ebd67&scoped=true&"
import script from "./GroupsFilterByGroup.vue?vue&type=script&lang=js&"
export * from "./GroupsFilterByGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560ebd67",
  null
  
)

export default component.exports